// Collaborate-invite landing copy (Iris, PLANS/WEB_READER_COVER_OPEN_SPEC.md).
// The web reader only ever shows COLLABORATIVE albums, so the landing leads with
// the sender's intent: they want the receiver to add their photos.

export function pagesLabel(n: number): string {
  return `${n} ${n === 1 ? "page" : "pages"}`;
}

export interface InviteCopy {
  headline: string;
  sub: string;
}

/** sender = manifest.sender.name (first name, or null). No she/he pronoun —
 *  the copy repeats the name (gender unknown from a first name). */
export function inviteCopy(
  sender: string | null | undefined,
  variant: "desktop" | "mobile",
): InviteCopy {
  const name = sender?.trim() || null;
  if (!name) {
    return {
      headline: "You’ve been invited to add your photos to this album.",
      sub:
        variant === "mobile"
          ? "Add yours to help fill the pages."
          : "Add yours to help fill the pages. The owner approves each one before it prints.",
    };
  }
  if (variant === "mobile") {
    return {
      headline: `${name} wants your photos in this album.`,
      sub: "Add yours to help fill the pages.",
    };
  }
  // Desktop — use the "is building" variant (safe for names ending in s).
  return {
    headline: `${name} is building an album — and wants your photos in it.`,
    sub: `Add yours to help fill the pages. ${name} approves each one before it prints.`,
  };
}
